import { ActionsButton } from '@/components/ActionsButton/ActionsButton';
import { formatIsoToDateTimeSlash } from '@/utils/timeFormatter';

import type { SubEvent } from './ItinerarySection';
import s from './ItinerarySection.module.scss';

type Props = {
  subEvent: SubEvent;
  onEdit: () => void;
  onDelete: () => void;
};

function ItineraryItem({ subEvent, onEdit, onDelete }: Props) {
  return (
    <div className={s.item}>
      <div className={s.itemMain}>
        <div className={s.itemHeader}>
          <span className={s.dot} />
          <span className={s.itemName}>{subEvent.title}</span>
        </div>
        <div className={s.itemBody}>
          <span className={s.itemDate}>{formatIsoToDateTimeSlash(subEvent.time_slot.start)}</span>
          {subEvent.description && (
            <span className={s.itemDescription}>{subEvent.description}</span>
          )}
        </div>
      </div>
      <ActionsButton
        variant="lite"
        items={[
          { label: 'Edit', onClick: onEdit },
          { label: 'Delete', onClick: onDelete, variant: 'danger' },
        ]}
      />
    </div>
  );
}

export default ItineraryItem;
